<template>
    <div class="table-list bill-detail">
        <alart-msg :display="alart.success" styleType="success" @alartStatus="alart.success = false">
            <span class="title" slot="title">{{msg.success}}</span>
            <span v-if="msg.successDes" class="description" slot="description">{{msg.successDes}}</span>
        </alart-msg>
        <alart-msg :display="alart.fail" styleType="error" @alartStatus="alart.fail = false">
            <span class="title" slot="title">{{msg.error}}</span>
        </alart-msg>
        <modal class="delete-bill" :display="modalStatus.deleteBill" @modalStatus="closeAlarmModal" >
            <img class="alarm-img" src="@/assets/img/icon/modal_alarm.svg" alt="">
            <h1>帳單刪除</h1>
            <div class="content">
                確定刪除 ”{{billName}}”的帳單嗎？記錄確認刪除將無法回復
            </div>
            <div class="btn-group">
                <button class="default-button" @click="deleteBill(), $analytics.logEvent('送出帳單刪除', { screen_name: '送出帳單刪除'})">確認</button>
                <button class="border-button" @click="closeAlarmModal">取消</button>
            </div>
        </modal>
        <bill-detail :billId="contractDetail.billId" :phone="contractDetail.phoneNumber"></bill-detail>
        <div class="mask"></div>
        <div class="table-list bill-record">
            <div class="table-list-title">
                <span class="created">建立時間</span>
                <span class="name">帳單名稱</span>
                <span class="paid">繳款時間</span>
                <span class="state">狀態</span>
                <span class="amount">帳單金額</span>
                <span class="action">操作</span>
            </div>
            <div id="bill-record" name="bill-record" class="table-list-body">
                <div v-show="contractDetail.billRecord.length == 0" class="is-empty">0 筆資料</div>
                <ul>
                    <li v-for="(bill,index) in contractDetail.billRecord" :key="index">
                        <span class="created">{{getFormatDate(bill.createdTime)}}</span>
                        <span class="name">{{bill.billName}}</span>
                        <span v-if="bill.actualPayTime" class="paid">{{getFormatDate(bill.actualPayTime)}}</span>
                        <span v-else class="paid">-</span>
                        <span class="state body blue" v-if="bill.billStatus == 'COMPLETELY_PAID'">已繳</span>
                        <span class="state body gray" v-if="bill.billStatus == 'UNPAID'">未繳</span>
                        <span class="state body red" v-if="bill.billStatus == 'OVERDUE'">欠款</span>
                        <span class="amount">{{toCurrency(bill.totalBillAmount)}}</span>
                        <span class="action">
                            <dot-dropmenu>
                                <ul >
                                    <li @click="setBillDetail(bill.billCid, bill.tenantPhone), $analytics.logEvent('帳單明細', { screen_name: '帳單明細'})">帳單明細</li>
                                    <li v-if="bill.billStatus != 'COMPLETELY_PAID'" @click="openAlarmModal(), billName = bill.billName, billId = bill.billCid">帳單刪除</li>
                                </ul>
                            </dot-dropmenu>
                        </span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import DotDropMenu from '@/components/widge/DotDropMenu.vue';
import Modal from '@/components/widge/Modal.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';
import newBill from '@/components/widge/newBill.vue';
import BillDetail from '@/components/widge/BillDetail.vue';

import { mapGetters } from 'vuex'
import { 
    getHouseDetail
} from "@/apis/company/houseMgt.js"; 
import { 
    apiGetContractHouse,
    apiGetContractBill,
    apiDeleteBill
    } from "@/apis/api.js"; 
export default {
    data () {
        return {
            contractDetail: {
                contractId: this.$route.query.cid,
                billId: null,
                phoneNumber: null,
                contractDetail: {},
                billRecord: []
            },
            houseDetail: {
                houseName: null,
                houseAddress: null,
            },
            billId: null,
            billName: null,
            alart: {
                success: false,
                fail: false
            },
            msg: {
                success: null,
                successDes: null,
                error: null,
            },
            modalStatus: {
                deleteBill: false
            },
        }
    },
    mounted () {
        // console.log(this.$route.query.cid)
        this.contractDetail.contractId = this.$route.query.cid
        this.$analytics.logEvent('合約帳單紀錄', { screen_name: '合約帳單紀錄'})
        this.getContractDetail()
        this.getContractBill()
    },
    watch: {
        houseDetail: {
            handler: function (val){
                this.$emit('houseDetail', val);
            },
            deep: true
        }
    },
    methods: {
        getContractDetail: function (){
            let data = this.contractDetail.contractId
            apiGetContractHouse(data)
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    // console.log(res)
                    this.contractDetail.contractDetail = res.data.result
                    this.getHouseDetail(res.data.result.houseCid)
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getHouseDetail: function (hid) {
            const data = {
                houseCid: hid,
                isLandlordWeb: true
            }
            getHouseDetail(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.houseDetail.houseName = res.data.result.houseDetail.name
                    this.houseDetail.houseAddress = res.data.result.houseDetail.address
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getContractBill: function () {
            let data = this.contractDetail.contractId
            apiGetContractBill(data)
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    console.log(res)
                    this.contractDetail.billRecord = res.data.result
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        setBillDetail: function (billCid, phone) {
            this.contractDetail.billId = billCid
            this.contractDetail.phoneNumber = phone
            this.$store.dispatch('setModalStatus', {state: true, type: 'billDetail'})
            this.$store.commit('modalStatus/set_modal_mode', true)
            document.getElementsByClassName('bill-detail-page')[0].style.zIndex = '9'
        },
        openAlarmModal: function () {
            this.modalStatus.deleteBill = true
            document.getElementsByClassName('bill-detail-page')[0].style.zIndex = '9'
            this.$store.commit('modalStatus/set_modal_mode', true)
        },
        closeAlarmModal: function () {
            this.$store.commit('modalStatus/set_modal_mode', false)
            this.modalStatus.deleteBill = false
        },
        deleteBill: function () {
            let data = {
                "billCid": this.billId
            }
            apiDeleteBill(data)
            .then( res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.getContractBill()
                    this.closeAlarmModal()
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        getFormatDate: function (date){
            var formatDate = [];
            var date = new Date(date);
            // var date = new Date(Date.parse(date));
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6];
            // return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6]+' '+formatDate[3]+':'+formatDate[4];
        },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     // console.log(parts);
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // },
    },
    // computed: {
    //     ...mapGetters({
    //         filterWord: 'GET_LEASE_MGT_FILTER_WORD',
    //         filterQuery: 'GET_LEASE_MGT_FILTER_QUERY',
    //     })
    // },
    components: {
        'dot-dropmenu': DotDropMenu,
        Modal,
        AlartMsg,
        newBill,
        BillDetail
    }
}
</script>
<style lang="scss" scoped>
    .table-list.bill-detail{
        .table-list{
            .table-list-title{
                padding: 24px 20px;
            }
            .table-list-body{
                .wrap{
                    padding: 24px;
                    display: flex;
                    span{
                        display: flex;
                        align-content: center;
                    }
                }
                .wrap.col{
                    flex-direction: column;
                    span{
                        margin-bottom: 16px;
                    }
                    span:last-child{
                        margin-bottom: 0px;
                    }
                }
            }
        }
        .table-list.bill-record{
            .table-list-body{
                >ul >li{
                    padding: 20px 20px;
                }
            }
            .name{
                width: 98px;
                margin-right: 136px;
            }
            .created{
                width: 100px;
                margin-right: 116px;
            }
            .amount{
                text-align: right;
                width: 60px;
                margin-right: 130px;
            }
            .paid{
                width: 80px;
                margin-right: 130px;
            }
            .state{
                width: 76px;
                margin-right: 130px;
            }
            .state.body{
                height: 38px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 4px;
            }
            .state.blue{
                background-color: rgba(113, 170, 229, 0.1);
            color: #71aae5;
            }
            .state.red{
                background-color: rgba(255, 146, 117, 0.1);
                color: #fc7171;
            }
            .state.gray{
                background-color: #f3f3f3;
                color: #676362;
            }
        }
        #modal.delete-bill{
            .modal-content{
                padding: 0 !important;
                .alarm-img{
                    margin-top: 40px;
                }
                h1{
                    font-size: 24px;
                    margin-top: 12px;
                    margin-bottom: 16px;
                }
                .content{
                    padding: 0 40px;
                    width: 368px;
                    line-height: 1.57;
                    color: #676362;
                    text-align: center;
                    margin-bottom: 50px;
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                    button:first-child{
                        margin-right: 14px;
                    }
                }
            }
        }     
      
    }
    @media screen and (max-width: 1280px){
        .table-list.bill-detail{
            .table-list.bill-record{
                .name{
                    width: 118px;
                    margin-right: 126px;
                }
                .created{
                    width: 90px;
                    margin-right: 126px;
                }
                .amount{
                    width: 72px;
                    margin-right: 122px;
                }
                .paid{
                    width: 90px;
                    margin-right: 126px;
                }
                .state{
                    width: 76px;
                    margin-right: 126px;
                }
                .state.body{
                    height: 38px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 4px;
                }
                .state.blue{
                    background-color: rgba(113, 170, 229, 0.1);
                    color: #71aae5;
                }
                .state.red{
                    background-color: rgba(255, 146, 117, 0.1);
                    color: #fc7171;
                }
                .state.gray{
                    background-color: #f3f3f3;
                    color: #676362;
                }
            }     
        }
    
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/leaseManagement/billDetailComp.vue